import keyMirror from 'keymirror';
// Todo: Move all these constants to ./proctor.js

// Refer: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia#exceptions
export const webcamDomException = keyMirror({
  AbortError: null,
  NotAllowedError: null,
  NotFoundError: null,
  NotReadableError: null,
  OverconstrainedError: null,
});

export const webcamExceptionMap = {
  NotAllowedError: webcamDomException.NotAllowedError,
  SecurityError: webcamDomException.NotAllowedError,
  NotReadableError: webcamDomException.NotReadableError,
  NotFoundError: webcamDomException.NotFoundError,
  OverconstrainedError: webcamDomException.OverconstrainedError,
};

// Single source of truth lives in `deviceErrorMessages.js`. Re-exported under
// the legacy name so existing consumers (e.g. preparedWebcamMessage) keep
// working. The map also includes plain-string entries for validation reasons
// like `blank` / `frozen` / `not-tested`, which lodash `_template` returns
// unchanged.
export const webcamDomExceptionMessage = {
  AbortError:
    'Your <%= webcamMicDisableText %> drivers are either not installed or not working properly. Please try re-installing the <%= webcamMicDisableText %> drivers.',
  NotAllowedError:
    'Your browser is blocking the <%= webcamMicDisableText %>. Please enable the <%= webcamMicDisableText %> from your browser settings and try again.',
  NotFoundError:
    'This device does not support the <%= webcamMicDisableText %> requirements for this <%= test_type_verbose %>. Please try taking the <%= test_type_verbose %> from another device.',
  NotReadableError:
    'Your <%= webcamMicDisableText %> drivers are already used by another process / application. <%= secureBrowserWebcamError %>',
  OverconstrainedError:
    'Selected <%= webcamMicDisableText %> is not detect please select different device and click on Test button',
};

export const SECURE_BROWSER_WEBCAM_ERROR =
  'or enable the camera permissions from system settings and try again.';

export const webcamWaitingMessage = 'Waiting for webcam...';
export const webcamOrMicWaitingMessage = 'Waiting for webcam or mic...';

export const webcamDisabledMessageTitle = 'Webcam not detected';

export const videoConstraints = {
  width: 640,
  height: 480,
  facingMode: 'user',
};
